<template>
    <div class="flex items-center justify-end mt-4 mr-5">
        <p class="mb-0 mr-4 ">Pular para a imagem</p>
        <input type="number" v-model="imageNumber" :max="max" :min="min" style="width: 60px;" />
        <vs-button size="small" class="ml-2" @click="goToImage">Ir</vs-button>
    </div>
</template>

<script>
export default {
    name: "DdCarouselNavigation",
    data() {
        return {
            imageNumber: 1
        };
    },
    props: {
        min: {
            default: 1,
            type: Number
        },
        max: {
            default: -1,
            type: Number
        }
    },
    methods: {
        goToImage() {
            const index = parseInt(this.imageNumber) - 1;
            this.$emit("goTo", index);
        }
    }
};
</script>
